import { useOrganization } from '@components/OrganizationBoundary';
import { nonNull } from '@helpers/non-null';
import { useTypedSelector } from '@hooks';
import ArchivedWorkspaceItem from '@pages/AdminSettings/components/OrganizationTab/components/OrganizationTabs/components/ArchivedWorkspaceItem';
import WorkspaceItemSkeleton from '@pages/AdminSettings/components/OrganizationTab/components/OrganizationTabs/components/WorkspaceItemSkeleton';

import {
  organizationArchivedWorkspaceFilteredCountStateSelector,
  organizationArchivedWorkspaceFilteredListStateSelector,
  organizationArchivedWorkspaceStateSelector
} from '@redux/selectors/organizations';
import { Empty } from 'antd';
import React, { memo } from 'react';

export default memo(function ArchivedWorkspacesTab() {
  const { currentOrganization } = useOrganization(true);
  const organization = nonNull(currentOrganization.entity);
  const organizationId = organization.id;

  const initiallyLoaded = useTypedSelector(
    (state) =>
      organizationArchivedWorkspaceStateSelector(state, { organizationId })
        .fetch.initiallyLoaded
  );

  const count = useTypedSelector((state) =>
    organizationArchivedWorkspaceFilteredCountStateSelector(state, {
      organizationId
    })
  );
  const list = useTypedSelector((state) =>
    organizationArchivedWorkspaceFilteredListStateSelector(state, {
      organizationId
    })
  );

  if (!initiallyLoaded)
    return (
      <div className="workspaces">
        {new Array(count).fill(undefined).map((_, idx) => (
          <WorkspaceItemSkeleton key={idx} />
        ))}
      </div>
    );

  if (list.length === 0)
    return (
      <div className="workspaces">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No archived workspaces"
          style={{ width: '100%' }}
        />
      </div>
    );

  return (
    <div className="workspaces">
      {list.map((it) => (
        <ArchivedWorkspaceItem key={it.id} workspace={it} />
      ))}
    </div>
  );
});
